"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isListTypeSection = void 0;
/**
 * Checks if the first field in the sortedFields array is of type 'list'.
 * @param sortedFields - An array of sorted fields.
 * @returns A boolean indicating whether the first field is of type 'list'.
 */
const isListTypeSection = (sortedFields) => {
    const parentField = sortedFields[0];
    if (parentField) {
        return parentField.field.field_type === 'list';
    }
    return false;
};
exports.isListTypeSection = isListTypeSection;
